<template>
  <Modal v-model="openMap" footer-hide width="230">
    <div>
      <div id="qrcode"></div>
      <div style="margin-top: 20px">
        <ly-form-item label="分享车辆">{{ item.carNo }}</ly-form-item>
        <ly-form-item label="截止时间">{{
          utils.time(item.endTime)
        }}</ly-form-item>
      </div>
      <div id="shareButton">
        <input id="href" type="text" v-model="item.href" readonly />
      </div>
      <Row>
        <Col span="12"
          ><Button @click="copy" long type="primary">复制链接</Button></Col
        >
        <Col span="12"><Button @click="jietu" long>下载二维码</Button></Col>
      </Row>
      <img style="display:none" src="static/logo/ewm.jpg" width="50" height="50" id="a333" alt="" />
    </div>
  </Modal>
</template>
<script>

export default {
  data() {
    return {
      openMap: false,
      item: {
        deviceNo: "",
        carNo: "",
        href: "",
        endTime: new Date(),
      },
    };
  },
  methods: {
    open(v) {
      console.log(v);
      this.item.carNo = v.carNo;
      this.item.deviceNo = v.deviceNo;
      this.openMap = true;
    },
    makeCode(data) {
      this.item = data;
      this.openMap = true;

      var divobj = document.getElementById("qrcode");
      divobj.innerHTML = "";
      divobj.title = "";
      var that = this;
      new QRCode(document.getElementById("qrcode"), {
        text: this.item.href,
        logo:document.getElementById("a333"),
        width: 200,
        height: 200,
        colorDark: "#15c415",
        colorLight: "#fff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      
    },
    copy() {
      var input = document.getElementById("href");
      href.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$Message.success("复制成功");
      }
    },
    end(t) {
      var now = Date.now();
      var to = t * 3600000;
      this.item.endTime = new Date(now + to);
    },
    jietu() {
      var ele = document.createElement("a");
      ele.setAttribute("href", this.htmlToImage()); //设置下载文件的url地址
      ele.setAttribute("download", "分享" + this.item.carNo); //用于设置下载文件的文件名
      ele.click();
    },
    htmlToImage() {
      var video = document.getElementById("qrcode");
      var canvas = video.getElementsByTagName("canvas")[0];
      return canvas.toDataURL("image/png");
    },
    reset() {
      var divobj = document.getElementById("qrcode");
      divobj.innerHTML = "";
      divobj.title = "";
      this.item.href = "";
    },
  },
  mounted() {
    this.end(2);
  },
};
</script>
<style lang="">
#qrcode {
  width: 200px;
  height: 200px;
  background: #ccc;
}
#shareButton {
  background: #fff;
}
#shareButton #href {
  width: calc(100% - 0px);
  border: none;
  background: none;
  height: 0px;
}
#shareButton #href:focus {
  border: none;
  outline: none;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/share/shareMakeCode.vue